<template>
    <el-switch
        ref="switchRef"
        v-if="permissionsShow"
        v-model="value"
        :active-color="activeColor"
        :inactive-color="inactiveColor"
        :active-text="activeText"
        :inactive-text="inactiveText"
        :active-value="activeValue"
        :inactive-value="inactiveValue"
        :width="width"
        :disabled="disabled"
        :active-icon-class="activeIconClass"
        :inactive-icon-class="inactiveIconClass"
        @change="_change"
    >
    </el-switch>
</template>
<script>
export default {
    props: {
        /* 组件默认值 */
        value: {
            type: [Boolean, String, Number],
            default: false
        },
        /* switch 打开时的背景色 */
        activeColor: {
            type: String
        },
        /* switch 关闭时的背景色 */
        inactiveColor: {
            type: String
        },
        /* switch 打开时的文字描述 */
        activeText: {
            type: String,
            default: function() {
                return 'ON';
            }
        },
        /* switch 关闭时的文字描述 */
        inactiveText: {
            type: String,
            default: function() {
                return 'OFF';
            }
        },
        /* switch 打开时的值 */
        activeValue: {
            type: [Boolean, String, Number],
            default: function() {
                return true;
            }
        },
        /* switch 关闭时的值 */
        inactiveValue: {
            type: [Boolean, String, Number],
            default: function() {
                return false;
            }
        },
        /* 是否禁用 */
        disabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 组件宽度 */
        width: {
            type: Number,
            default: 40
        },
        activeIconClass: {
            type: String,
            default: ''
        },
        inactiveIconClass: {
            type: String,
            default: ''
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
    },
    methods: {
        /* 组件当前状态改变时回调父组件 */
        _change(value) {
            this.$emit('change', value);
            this.$emit('input', value);
        },
        /* 使 Switch 获取焦点 */
        focus() {
            this.$refs.switchRef.focus();
        }
    }
};
</script>
